import Text from '@components/Text';
import colors from '@constants/colors';
import { ReactNode } from 'react';

import styles from './styles.module.scss';

interface Props {
    title: string;
    children?: ReactNode;
}

function Note({ title, children }:Props) {
    return (
        <div className={styles.container}>
            <Text color={colors.gray6} fontWeight='bold'>{title}</Text>
            <Text color={colors.gray6}>
                {children}
            </Text>
        </div>
    );
}

export default Note;
